// A safe wrapper around localStorage that catches errors when storage is disabled
export const safeLocalStorage = {
  getItem: (key: string) => {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },

  setItem: (key: string, value: string) => {
    try {
      localStorage.setItem(key, value);
    } catch {
      throw new Error(
        "Your browser’s privacy settings are blocking storage. To continue, allow site storage or exit private browsing."
      );
    }
  },

  removeItem: (key: string) => {
    try {
      localStorage.removeItem(key);
    } catch {
      /* ignore */
    }
  },
};
